import React, { Component, createRef } from "react";
import Logo from "../assets/logo.png";
import "../style/Nav.css";
import { Link } from "react-router-dom";
export class Nav extends Component {
  constructor() {
    super();
    this.walletAddressBtnRef = createRef();
    this.state = {
      address: "",
    };
  }

  shortenAddress(address) {
    if (address) {
      const charsStartAndEndNumber = 6;
      return (
        address.substr(0, charsStartAndEndNumber) +
        "..." +
        address.substr(address.length - charsStartAndEndNumber, address.length)
      );
    }
    return undefined;
  }

  async connectWallet() {
    if (!window.cardano) {
      alert("Install Nami Wallet!");
      return;
    }
    let isEnabled = await window.cardano.enable();
    if (!isEnabled) return;
    let address = (await window.cardano.getUsedAddresses())[0];
    // this.walletAddressBtnRef.current.innerHTML = this.shortenAddress(address);
    // this.walletAddressBtnRef.current.onclick = null;
    this.setState({
      address: this.shortenAddress(address),
    });
  }

  componentDidMount() {
    (async () => {
      if (!window.cardano) return;
      let isEnabled = await window.cardano.isEnabled();
      if (!isEnabled) return;
      let address = (await window.cardano.getUsedAddresses())[0];
      this.setState({
        address: this.shortenAddress(address),
      });
    })();
  }

  render() {
    return (
      <div id="nav">
        <div id="navTop">
          <button
            onClick={async () => {
              await this.connectWallet();
            }}
            ref={this.walletAddressBtnRef}
            id="connectWalletBtn"
          >
            {this.state.address.length > 0
              ? this.state.address
              : "Connect Wallet"}
          </button>
        </div>
        <Link to="/">
          {" "}
          <img src={Logo} alt="" id="navLogo" />
        </Link>
      </div>
    );
  }
}

export default Nav;
